export const user = {
    isHod: false,
    isAlumniCoordinator: true,
    isPricipal: false,
    department: '',
};